/*
* StorageManager.ts
* @author Abhilash Panwar (abpanwar) Hector Hernandez (hectorh)
* @copyright Microsoft 2020
* File containing apis to help store properties in storage.
*/
import { getGlobal, Utils } from '@microsoft/1ds-core-js';
import { _EISessionKey, _EIPreviousKey, _MSEI } from './Constants';
/**
 * This class adds ability to store properties in various types of storages or custom storage.
 * TODO(abpanwar): This class will change once we add support for other storage types, custom storage and error handling.
 */
var StorageManager = /** @class */ (function () {
    /**
     * Creates an instance of the storage manager class to determine the storage that needs to be used.
     * @param storageDisabled Whether storage is disabled due to user not providing consent.
     */
    function StorageManager(storageDisabled) {
        this._storage = StorageManager._getLocalStorage();
        if (storageDisabled && this._storage) {
            this._deleteAllStorage();
        }
    }
    /**
     * Get local storage if available.
     */
    StorageManager._getLocalStorage = function () {
        var global = getGlobal() || {};
        return (global['localStorage']);
    };
    /**
     * Stores a key value pair in the chosen storage.
     * @param key key to be stored
     * @param value value to be stored
     */
    StorageManager.prototype._setProperty = function (key, value) {
        this._storage.setItem(key, value);
    };
    /**
     * Returns a value associated with the passed key. Null if key is not present.
     * @param key key to be used to return the value
     */
    StorageManager.prototype._getProperty = function (key) {
        return this._storage.getItem(key);
    };
    /**
     * Deletes all data stored in cookies or local storage.
     */
    StorageManager.prototype._deleteAllStorage = function () {
        this._storage.removeItem(_EISessionKey);
        this._storage.removeItem(_EIPreviousKey);
        Utils.deleteCookie(_MSEI);
    };
    return StorageManager;
}());
export default StorageManager;
//# sourceMappingURL=StorageManager.js.map